import queryString from 'query-string';
import http from '../httpConfig';
import { API_ENDPOINTS } from '../utils/apiConstant';
import { buildPagingResponse } from '../utils/methods';
import { List, AddEditApi } from '../interfaces/developer.interface';

const list = (payload: List) => {
  const { searchText, status, cityId, stateId, countryId, ...others } = payload;
  const paging = buildPagingResponse(others);
  const url = `${API_ENDPOINTS.listDevelopers}?${queryString.stringify(paging)}`;
  return http.post(url, {
    search: searchText,
    is_active: status === '1' ? 1 : status === '0' ? 0 : '',
    city_id: cityId ? Number(cityId) : '',
    state_id: stateId ? Number(stateId) : '',
    country_id: countryId ? Number(countryId) : '',
    created_by: '',
  });
};

const add = (payload: AddEditApi | FormData) => {
  if (payload instanceof FormData) {
    return http.post(API_ENDPOINTS.addDeveloper, payload, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
  const { cityId, stateId, countryId, areaId, order_by: _order_by, ...rest } = payload;
  return http.post(API_ENDPOINTS.addDeveloper, {
    ...rest,
    city_id: cityId,
    state_id: stateId,
    country_id: countryId,
    area_id: areaId,
  });
};

const edit = (id: string, payload: AddEditApi | FormData) => {
  if (payload instanceof FormData) {
    return http.post(`${API_ENDPOINTS.editDeveloper}/${id}`, payload, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
  const { cityId, stateId, countryId, areaId, order_by: _order_by, ...rest } = payload;
  return http.put(`${API_ENDPOINTS.editDeveloper}/${id}`, {
    ...rest,
    city_id: cityId,
    state_id: stateId,
    country_id: countryId,
    area_id: areaId,
  });
};

const get = (id: string) => {
  return http.get(`${API_ENDPOINTS.getDeveloper}/${id}`);
};

const kpis = () => {
    return http.get(API_ENDPOINTS.developerKpis);
};

const lookup = (payload: { searchText: string; is_active?: number | string }) => {
  const queryParams = {
    search: payload.searchText,
    exclude: 'users',
    exclude_id: 2,
    is_active: payload.is_active
  };
  const url = `${API_ENDPOINTS.lookupDevelopers}?${queryString.stringify(queryParams)}`;
  return http.get(url).then((response: any) => response.records || []);
};

const deleteLogo = (id: string | number) => {
  return http.delete(`${API_ENDPOINTS.addDeveloper}/${id}/logo`);
};

const exportAll = () =>
  http.get(API_ENDPOINTS.developerExport, { responseType: 'blob' });

const DeveloperService = {
  list,
  add,
  edit,
  get,
  kpis,
  lookup,
  deleteLogo,
  exportAll,
};

export default DeveloperService;
